import { render, staticRenderFns } from "./FormulaQnaMngt.vue?vue&type=template&id=077c7df8"
import script from "./FormulaQnaMngt.vue?vue&type=script&lang=js"
export * from "./FormulaQnaMngt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports